<template>
    <div class="total-comment">
       <div class="left">
        <div class="total-star-text">综合评星</div>
        <div class="line"></div>
        <div class="score">{{ avgScore }}</div>
        <div class="star">
            <el-rate
                v-model="avgScore2"
                disabled
                :colors="['#FF7E00', '#FF7E00', '#FF7E00']"
                :allow-half="true"	>
            </el-rate>

        </div>
        <!-- <div class="people-score">{{evaluteCount}}人评分</div> -->
       </div>
       <div class="right">
        <div class="five-star item">
            <div class="label">五星</div>
            <div class="progress"><el-progress :show-text="false" :percentage="fiveStarRadio" :color="customColor"></el-progress></div>
            <div class="radio">{{ fiveStarRadio+"%" }}</div>
        </div>
        <div class="four-star item">
            <div class="label">四星</div>
            <div class="progress"><el-progress :show-text="false" :percentage="fourStarRadio" :color="customColor"></el-progress></div>
            <div class="radio">{{ fourStarRadio+"%" }}</div>
        </div>
        <div class="three-star item">
            <div class="label">三星</div>
            <div class="progress"><el-progress :show-text="false" :percentage="threeStarRadio" :color="customColor"></el-progress></div>
            <div class="radio">{{ threeStarRadio+"%" }}</div>
        </div>
        <div class="two-star item">
            <div class="label">二星</div>
            <div class="progress"><el-progress :show-text="false" :percentage="twoStarRadio" :color="customColor"></el-progress></div>
            <div class="radio">{{ twoStarRadio+"%" }}</div>
        </div>
        <div class="one-star item">
            <div class="label">一星</div>
            <div class="progress"><el-progress :show-text="false" :percentage="oneStarRadio" :color="customColor"></el-progress></div>
            <div class="radio">{{ oneStarRadio+"%" }}</div>
        </div>
       </div>
    </div>
</template>

<script>
export default {
    props: {
        score: {
            Type: Number,
            default: 0
        },
        evaluteCount: {
            Type: Number,
            default: 0,
        },
        oneStarCount: {
            Type: Number,
            default: 0,
        },
        twoStarCount: {
            Type: Number,
            default: 0,
        },
        threeStarCount: {
            Type: Number,
            default: 0,
        },
        fourStarCount: {
            Type: Number,
            default: 0,
        },
        fiveStarCount: {
            Type: Number,
            default: 0,
        },
        
    },
    data() {
        return {
            customColor:'#FF7E00',
        }
    },
    computed:{
        avgScore(){
            console.log("this.score",this.score)
            console.log("this.evaluteCount",this.evaluteCount)
            if(!this.score || !this.evaluteCount){
                return 0;
            }
            console.log("avgScore",(this.score/this.evaluteCount).toFixed(2))
            return (this.score/this.evaluteCount).toFixed(2);
        },
        avgScore2(){
            console.log("this.score",this.score)
            console.log("this.evaluteCount",this.evaluteCount)
            if(!this.score || !this.evaluteCount){
                return 0;
            }
            console.log("avgScore",(this.score/this.evaluteCount).toFixed(2))
            return Number((this.score/this.evaluteCount).toFixed(2));
        },
        oneStarRadio(){
            if(!this.oneStarCount || !this.evaluteCount){
                return 0;
            }
            return (this.oneStarCount*100/this.evaluteCount).toFixed(2);
        },
        twoStarRadio(){
            if(!this.twoStarCount || !this.evaluteCount){
                return 0;
            }
            return (this.twoStarCount*100/this.evaluteCount).toFixed(2);
        },
        threeStarRadio(){
            if(!this.threeStarCount || !this.evaluteCount){
                return 0;
            }
            return (this.threeStarCount*100/this.evaluteCount).toFixed(2);
        },
        fourStarRadio(){
            if(!this.fourStarCount || !this.evaluteCount){
                return 0;
            }
            return (this.fourStarCount*100/this.evaluteCount).toFixed(2);
        },
        fiveStarRadio(){
            if(!this.fiveStarCount || !this.evaluteCount){
                return 0;
            }
            return (this.fiveStarCount*100/this.evaluteCount).toFixed(2);
        },

    },
    watch: {
       
    },
    methods: {
      
    }
}
</script>

<style lang="scss" scoped>
.total-comment{
    display: flex;
    justify-content: space-between;
    .left{
        width: 340px;
        position:relative;
        border: 1px solid #eaeaea;
        margin-right: 30px;
        .total-star-text{
            height: 70px;
            line-height: 70px;
            font-size: 34px;
            color: #333;
            text-align: center;
            border-bottom: 1px solid #eaeaea 
        }
        .score{
            height: 120px;
            line-height: 120px;
            font-size: 50px;
            color: #999;
            text-align: center;
            font-weight: bold;
        }
        .star{
            text-align: center;
            margin-top: 20px;
            width: 100%;
        }
        .people-score{
            bottom: 10px;
            text-align: center;
            height: 30px;
            margin-top: 10px;
            line-height: 30px;
            font-size: 26px;
            color: #999
        }
    }
    .right{
        display: flex;
        flex-direction: column;
        width: 100%;
        align-items: center;
        .item{
            display: flex;
            color: #999;
            height: 60px;
            align-items: center;
            width:100%; 
            .label{
                width: 60px;
                color: #bbb
            }
           .progress{
              flex: 1;  
            }
            .radio{
                width: 60px;
                color: #bbb
            }
        }
    }
}
</style>
<style scoped>
    .total-comment >>> .el-rate__icon{
        font-size: 28px;
        margin-left: 6px;
        margin-right: 6px;
    }
    .total-comment >>> .el-progress-bar__inner{
        font-size: 28px;
        margin-left: 6px;
        margin-right: 6px;
        background-color:#007741
    }
</style>



// WEBPACK FOOTER //
// src/components/comment/totalComment.vue